export enum AttendanceViewMode {
    Calendar = "Calendar",
    Table = "Table"
}

export enum AttendanceFastEntry {
    Absence = "Absence",
    Work = "Work"
}